const DEFAULT_SELLER_CARD_THRESHOLDS = {
  maxAgeing: {
    greenMin: 0,
    greenMax: 30,
    amberMin: 31,
    amberMax: 45,
    redMin: 46,
    redMax: 100,
  },
  overdueOrders: {
    redWhenGreaterThan: 0,
  },
  // fgReadiness: {
  //   greenStatuses: ["ON_TIME"],
  //   amberStatuses: ["DUE_TODAY"],
  //   redStatuses: ["DUE_PASSED"],
  // },
  fgReadiness: {
    greenMin: 80,
    greenMax: 100,
    amberMin: 70,
    amberMax: 79,
    redMax: 69,
    redMin: 0,
  },
  onTime: {
    greenMin: 80,
    greenMax: 100,
    amberMin: 70,
    amberMax: 79,
    redMax: 69,
    redMin: 0,
  },
  inFull: {
    greenMin: 90,
    greenMax: 100,
    amberMin: 75,
    amberMax: 90,
    redMax: 74,
    redMin: 0,
  },
};

export { DEFAULT_SELLER_CARD_THRESHOLDS };
